import type { AnaliseAdicionada, typeMalhaPontos } from '../types'

/** Converte "R$ 1.234,56" em Number. */
function parseValorBRL(valor?: string): number {
  if (!valor) return 0
  const limpo = String(valor)
    .replace(/\./g, '') // milhar
    .replace(',', '.') // decimal
    .replace(/[^\d.-]/g, '') // R$ e espaços
  const n = parseFloat(limpo)
  return isNaN(n) ? 0 : n
}

/**
 * Transforma o estado de análises no formato esperado pelo POST de OS
 * (mesma estrutura do módulo antigo: analises tratadas + malha + valor total).
 */
export function montarAnalisesPayload(analises: AnaliseAdicionada[], malhaShp: typeMalhaPontos) {
  const analisesTratadas = (analises ?? []).map((item) => ({
    title: item?.analise_nome,
    cod_analises: {
      cod: item?.cod_analise,
      valor: Number(item?.valor) || 0,
    },
    id: String(item?.id ?? ''),
    pontos: (item?.pontos_selecionados ?? []).map((p) => ({
      NOME: p?.NOME,
      INDICE: p?.INDICE,
      COMENTARIO: '',
      LATITUDE: p?.LATITUDE,
      LONGITUDE: p?.LONGITUDE,
    })),
    valor_analise: parseValorBRL(item?.valor_analise),
  }))

  const valor = analisesTratadas.reduce((acc, item) => acc + (item.valor_analise || 0), 0)

  const malhaShpComData = {
    ...malhaShp,
    features: (malhaShp?.features ?? []).map((feature) => ({
      ...feature,
      properties: {
        ...feature?.properties,
        DATA: null,
      },
    })),
  }

  return {
    analises: analisesTratadas,
    malha_de_pontos: malhaShpComData,
    valor,
  }
}
